
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8cc19112&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Aside.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Aside.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8cc19112!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Aside.vue"),
  /* scopeId */
  "data-v-8cc19112",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/private/layout/Aside.vue
// module id = 88
// module chunks = 1